import type { ISerialize } from '@/objects/ISerialize';
import { formatDateIso } from '@/utilities/dateutils';

export class ProductionKeepAlive implements ISerialize {
    public DeviceId: string;

    public EventId: number;

    public LastSeen: Date;

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { DeviceId?: string | null; EventId?: number; LastSeen?: Date }) {
        this.DeviceId = values.DeviceId ?? '';

        this.EventId = values.EventId ?? 0;

        this.LastSeen = values.LastSeen ?? new Date('1970-01-01T00:00:00.000');
    }

    public serialize(): string {
        return (
            '{' +
            `"DeviceId": ${JSON.stringify(this.DeviceId)}` +
            ',' +
            `"EventId": ${JSON.stringify(this.EventId)}` +
            ',' +
            `"LastSeen": ${'"' + formatDateIso(this.LastSeen) + '"'}` +
            '}'
        );
    }

    /**
     * Creates an instance of ProductionKeepAlive from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { DeviceId?: string | null; EventId?: number; LastSeen?: Date }): ProductionKeepAlive {
        return new ProductionKeepAlive(values);
    }

    public static _FromServerJson(json: any): ProductionKeepAlive {
        return new ProductionKeepAlive({
            DeviceId: json.DeviceId ?? '',
            EventId: json.EventId,
            LastSeen: json.LastSeen instanceof Date ? json.LastSeen : new Date(json.LastSeen),
        });
    }

    /**
     * Creates an instance of ProductionKeepAlive from another instance of ProductionKeepAlive.
     * @param other The ProductionKeepAlive you want to clone
     * @returns A cloned ProductionKeepAlive
     */
    public static FromOther(other: ProductionKeepAlive): ProductionKeepAlive {
        return ProductionKeepAlive._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return ProductionKeepAlive.FromOther(this);
    }

    static NAME_OF_CLASS = 'ProductionKeepAlive';
}
